import React from "react";

interface MetricsBadgeProps {
    label: string;
    testId?: string;
    text: string;
}

const MetricsBadge: React.FC<MetricsBadgeProps> = ({ label, testId, text }) => (
    <div className="metrics-badge">
        <div className="metrics-badge__label">{label}</div>
        <div className="metrics-badge__bar-container">
            <div className="metrics-badge__bar" data-testid={testId}>
                <span className="metrics-badge__bar-text">{text}</span>
            </div>
        </div>
    </div>
);

export default MetricsBadge;
